import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect, useState } from 'react';

function GoogleRecaptcha({
    onChange,
    error,
    siteKey = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY,
}) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return isClient ? (
        <div className={'flex flex-col items-center justify-center'}>
            <ReCAPTCHA sitekey={siteKey} onChange={(value) => onChange(value)} />
            <div className='text-red mx-automt-1 flex max-w-[382px] justify-start text-left text-sm'>
                {error}
            </div>
        </div>
    ) : null;
}
export default GoogleRecaptcha;
